
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class ArizaBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "ArizaBasvuruSave";
    super(baseUrl);
  }


  saveArizaBasvuruSave(request: ArizaBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new ArizaBasvuruAPI();

class ArizaBasvuruSaveRequest {
    sicilKodu: number;
    basvuruTuruId: number;
    aboneNo: number;
    aciklama: string;
    captchaToken?: string;

    constructor(sicilKodu: number, basvuruTuruId: number, aboneNo: number, aciklama: string,captchaToken?: string) {
        this.sicilKodu = sicilKodu;
        this.basvuruTuruId = basvuruTuruId;
        this.aboneNo = aboneNo;
        this.aciklama = aciklama;
        this.captchaToken = captchaToken;
    }
}
export { ArizaBasvuruSaveRequest };
